module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Death March Through Russia")])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This English-language edition")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("first published in 2019 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Greenhill Books,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("c/o Pen & Sword Books Ltd,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("47 Church Street, Barnsley,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("S. Yorkshire, S70 2AS")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.greenhillbooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.greenhillbooks.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:contact@greenhillbooks.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("contact@greenhillbooks.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN: 978-1-78438-503-3")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN: 978-1-78438-504-0")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Mobi ISBN: 978-1-78438-505-7")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Publishing History")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("First published in German in 2017 as")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Todesmarsch durch Russland: Mein Weg in die Kriegsgefangenschaft")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("by Edition Förg (Rosenheim).")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This is the first English-language edition and includes a new foreword by Roger Moorhouse.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Klaus Willmann text © Edition Förg GmbH 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Roger Moorhouse foreword © Greenhill Books, 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Translation by Eva Burke © Greenhill Books, 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The right of Klaus Willmann to be identified as author of this work has been asserted in accordance with Section 77 of the Copyrights Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("CIP data records for this title are available from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Designed and typeset by Donald Sommerville")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0